<template>
    <div>
        <!--<div class="breadcrumb-layout" v-if="orderId == null">-->
        <!--<el-breadcrumb separator="/">-->
        <!--<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
        <!--<el-breadcrumb-item>派工单列表</el-breadcrumb-item>-->
        <!--</el-breadcrumb>-->
        <!--</div>-->
        <div class="org-tree-layout">
            <swb-popover-org-tree :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area  ref="query_model_ctrl"  :confKey="confKey" :configAuto="configAuto" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div name="btn-bar" class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="exportExcel">
                    <span>导出excel</span>
                </button>
            </div>
            <div class="right">
                <button class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('closed')" @click="doCloseForBatch">批量关闭</button>
                <button class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('update_servicerTag')" @click="toServicerTag">设置标签</button>
                <button class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('update_performflag')" @click="doUpdatePerformFlagBatch">设置绩效标记</button>
                <button class="swb-btn swb-btn-small swb-btn-primary" v-if="checkActionPerm('grab_set')" @click="doGrabSetBatch">批量发起抢单</button>
            </div>

        </div>

        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="configAuto" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes, getDefaultDownloadPageSize } from '../../app.conf'
    import { showGrpDownloadDlg } from '../ctrl/dialog'
    import { checkUserActionPerm } from '../index'
    import { openWorkVoucherDetailDlg, openWorkVoucherRecsDlg, openDeviceRepairRecDlg, openServcWorkStaffQualiDlg } from './showDetailDlg'
    import { openStaffQualiForSelectDlg } from '../quali/selectDlg';
    import { openServicerComForSelectDlg, openServicerComTreeSelectDlg } from '../orgStruct/selectDlg';

    import servcDelivApi from '../../api/servcDeliv'
    import servcCategApi from '../../api/servcCateg'

    import userApi from '../../api/user'
    //
    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);
    //
    import SwbServcOrderOperate from '../servcOrder/ServcOrderOperate';
    Routes.add(SwbServcOrderOperate);

    import SwbToChangeEngineers from './ToChangeEngineers';
    Vue.regist(SwbToChangeEngineers);

    import SwbServicerComForSelect from '../orgStruct/ServicerComForSelect';
    Vue.regist(SwbServicerComForSelect);

    import SwbServcWorkVoucherSearch from './ServcWorkVoucherSearch';
    Vue.regist(SwbServcWorkVoucherSearch);

    import SwbServcWorkVoucherArrangePlan from './ServcWorkVoucherArrangePlan';
    Vue.regist(SwbServcWorkVoucherArrangePlan);

    import SwbServcEvalList from '../servcOrder/ServcEvalList';
    Routes.add(SwbServcEvalList);

    // 订单收费项
    import SwbServcOrderChargeItemList from './ServcOrderChargeItemList';
    Vue.regist(SwbServcOrderChargeItemList);

    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';
    Routes.add(SwbTradeVoucherList);

    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    Vue.regist(SwbPopoverOrgTree);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    let searchConfigData = {};
    export default {
        name: 'swb-servc-work-voucher-list',
        path: '/servc/work/voucher/list',
        avlActions: 'view_detail|to_order_list|work_voucher_to_others|invalidate|to_request_assist|relieve_serve_interrupt|appoint_engineer|view_rec|view_charge_item|to_request_dispatch',
        avlScopes: 'servicer',
        notAsResc: false,
        authen: false,
        desc: '服务派工单列表',
        props: {
            orderId: {
                type: Number,
            }
        },
        data: function () {
            return {
                //
                confKey: 'swb-servc-work-voucher-list',
                configAuto: true,
                theTableHeight: '300',
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 300,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //
                emgLevelMap: getEnumMap('emgLevel', 'value2text'),
                reqVoucherId: null,
                invalid: null,
                no: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                showServcEval: false,
                shopFlag: null,
                currentComId: null,
                treeCollapse: true,
                thisComId: null,
                thisComLevel: null,
                includeSubComs: false,
                initIncludeSubComs: false,
                workServcTypeMap: {},
                workAssignStateMap: {},
                // 巡查工单
                servcTypePatrol: null,
                // 保养工单
                servcTypeMaint: null,
                // 培训指导工单
                servcTypeGuidance: null,
                // 已支援
                supportedState: null,
                exportParams: {},
                selectList: [],
                merchantId: null,
                performFlagEnumMap: {},
                servicerTagList: null,
                refreshFlag: '',
                showQuery: true,
            }
        },
        created: function () {
            this.getCurrentUserInfo();
            //
            //保持pageSize的一致性
            this.reqVoucherId = this.$route.query.reqVoucherId || null;
            this.invalid = this.$route.query.invalid || null;
            this.no = this.$route.query.no || null;
            if(!Utils.isNoB(this.no)) {
                this.queryModel.filterItems.no = this.no;
                this.includeSubComs = true;
                this.initIncludeSubComs = true;
            }
            this.queryModel.filterItems.closed = false;
            //
            this.workServcTypeMap = getEnumMap('workServcType', 'value2text');
            this.workAssignStateMap = getEnumMap('workAssignState', 'value2text');
            this.supportedState = getEnumInfoWith("workAssignState", 'name', 'Supported').value;
            this.servcTypePatrol = getEnumInfoWith("workServcType", 'name', 'PatrolServc').value;
            this.servcTypeMaint = getEnumInfoWith("workServcType", 'name', 'ProductMaint').value;
            this.servcTypeGuidance = getEnumInfoWith("workServcType", 'name', 'TrainingGuidance').value;
            this.performFlagEnumMap = getEnumMap('performFlag', 'value2text');
            //
            this.getServcWorkVoucherList();
            this.getServicerTagList();
            //
            this.showServcEval = checkUserActionPerm.call(this);
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout, .org-tree-layout, [name="query-sort-block"],[name="btn-bar"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {
                let self = this;
                self.getMerchtFusedServcCat(function (result) {
                    let dataList = result;
                    self.updateQueryModelField("catId", dataList)
                })
                //
                self.getServcWorkVoucherServicerTagList(function (result) {
                    let dataList = result;
                    self.updateQueryModelField("servicerTag", dataList)
                })
                //
                self.getWorkServcType(function (result) {
                    let dataList = result;
                    self.updateQueryModelField("servcType", dataList)
                })
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'no': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '<span>' + row.no + '</span>';
                        if(row.requestProxied) {
                            domHtml = domHtml + '<i class="table-tips"></i>';
                        }
                        if(row.qualiClaimFlag) {
                            domHtml = domHtml + '<i name="quali_claim" class="table-qualific"></i>';
                        }
                        return domHtml;
                    },
                    'dlgtFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.dlgtFlag) {
                            return '<span class="swb-tags swb-tags-danger mr5">委托</span>';
                        }
                    },
                    'dlgtInspectFinished': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.dlgtInspectFinished) {
                            return '<span class="swb-tags swb-tags-success mr5">约检完成</span>';
                        }
                    },
                    'dlgtMaintFinished': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.dlgtMaintFinished) {
                            return '<span class="swb-tags swb-tags-success mr5">约保完成</span>';
                        }
                    },
                    'tradeNo': function (row, colName, colValue, rowIndex, colConf) {
                        if(self.checkActionPerm('to_trade_voucher') && row.tradeId != null && row.tradeId != -1) {
                            return '<a href="#" style="color:purple;">' + row.tradeNo + '</a>';
                        } else {
                            return row.tradeNo != null ? '<span>' + row.tradeNo + '</span>' : '<span></span>';
                        }
                    },
                    'emgLevel': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.emgLevel == 0) {
                            return '<span class="swb-tags swb-tags-success">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        } else if(row.emgLevel == 1) {
                            return '<span class="swb-tags swb-tags-warning">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        } else {
                            return '<span class="swb-tags swb-tags-danger">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        }
                    },
                    'grabFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.grabFlag) {
                            return '<span>' + "抢单" + '</span>';
                        } else {
                            return '<span>' + "指派" + '</span>';
                        }
                    },
                    "servcType": function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if(row.servcType != null) {
                            domHtml = domHtml + '<span class="swb-tags swb-tags-success">' + self.workServcTypeMap[row.servcType] + '</span>';
                        }
                        if(row.remoted) {
                            domHtml = domHtml + '<span class="swb-tags swb-tags-success">' + "远程解决" + '</span>'
                        }
                        return domHtml;
                    },
                    'state': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.closed) {
                            return '<span class="font-red">' + "已关闭" + '</span>'
                        } else if(row.invalid) {
                            return '<span class="font-red">' + "已作废" + '</span>'
                        } else if(row.stateText == '服务暂停') {
                            return '<span class="font-red">' + '原因:' + row.stateDesc + '</span>'
                        } else {
                            return row.stateText;
                        }
                    },
                    'orderNo': function (row, colName, colValue, rowIndex, colConf) {
                        if(self.checkActionPerm('to_order_list')) {
                            return row.orderNo != null ? '<a href="#" style="color:purple;">' + row.orderNo + '</a>' : null;
                        } else {
                            return row.orderNo != null ? row.orderNo : null
                        }
                    },
                    'amount': function (row, colName, colValue, rowIndex, colConf) {
                        return row.amount != null ? (row.amount).toFixed(2) : 0.00;
                    },
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        return '<a><img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/></a>';
                    },
                    'staffQuali': function (row, colName, colValue, rowIndex, colConf) {
                        return '<a href="#" style="color:purple;">' + "个人资质" + '</a>'
                    },
                    'srcMerchantName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.servcReqVoucher != null && row.servcReqVoucher.srcMerchantType == 2) {
                            return row.servcReqVoucher.srcMerchantName
                        }
                    },
                    'beyondWrnt': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.beyondWrnt) {
                            return '<span class="swb-tags swb-tags-danger">' + "约定外" + '</span>'
                        } else {
                            return '<span class="swb-tags swb-tags-success">' + "约定内" + '</span>'
                        }
                    },
                    'evalFlag': function (row, colName, colValue, rowIndex, colConf) {
                        return row.evalFlag ? '是' : '否';
                    },
                    'performFlag': function (row, colName, colValue, rowIndex, colConf) {
                        return self.performFlagEnumMap[row.performFlag]
                    },
                    'servicerTag': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.servicerTag) {
                            return '<span :title="row.servicerTag" class="swb-tags swb-tags-success">' + row.servicerTag + '</span>'
                        }
                    },
                    'jbAmount': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.performFlag == 2 && row.finished) {
                            return '<span>' + row.jbAmount + '</span>'
                        }
                    },
                    'repaireTimeMi': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.repaireTimeMi != null) {
                            return '<span>' + (row.repaireTimeMi / 60).toFixed(2) + '</span>';
                        } else {
                            return '<span>' + 0.00 + '</span>'
                        }
                    },
                    'servRepaireTimeMi': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.servRepaireTimeMi != null) {
                            return '<span>' + (row.servRepaireTimeMi / 60).toFixed(2) + '</span>';
                        } else {
                            return '<span>' + 0.00 + '</span>'
                        }
                    },
                    'repaireTimeH': function (row, colName, colValue, rowIndex, colConf) {
                        return row.repaireTimeH.toFixed(2)
                    },
                    'servRepaireTimeMiH': function (row, colName, colValue, rowIndex, colConf) {
                        return row.servRepaireTimeMiH.toFixed(2)
                    },
                    'reputably': function (row, colName, colValue, rowIndex, colConf) {
                        return ((row.attitudeScore || 0) + (row.skillsScore || 0) + (row.qualityScore || 0)) == 15 ? '是' : '否';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        if(self.checkActionPerm('view_detail')) {
                            domHtml = domHtml + '<a name="view_detail" class="swb-btn swb-btn-link">查看详情</a>';
                        }
                        if(row.tmpNo != null) {
                            domHtml = domHtml + '<a name="device-repair-rec" class="swb-btn swb-btn-link">维保记录</a>';
                        }
                        if(self.checkActionPerm('work_voucher_to_others') && (row.state == 3 || row.state == 7) && row.engineerId != null && !row.invalid && !row.grabFlag) {
                            domHtml = domHtml + '<a name="work_voucher_to_others" class="swb-btn swb-btn-link">转单</a>';
                        }
                        if(self.checkActionPerm('invalidate') && !row.invalid && row.state != self.supportedState && (row.state < 9 || row.state == 15) && (!row.grabFlag || row.buyerId == null)) {
                            domHtml = domHtml + '<a name="invalidate" class="swb-btn swb-btn-link">作废</a>';
                        }
                        if(self.checkActionPerm('closed') && !row.closed && row.closedState > 0) {
                            domHtml = domHtml + '<a name="closed" class="swb-btn swb-btn-link">关闭</a>';
                        }
                        if(self.checkActionPerm('to_request_assist') && row.svcDispLevel < 3 && (row.state < 9 || row.state == 15) && !row.invalid && row.state != self.supportedState && !row.maintFlag && !row.remoted && row.servcType != self.servcTypeGuidance && row.servcType != self.servcTypePatrol && row.servcType != self.servcTypeMaint && !row.grabFlag) {
                            domHtml = domHtml + '<a name="to_request_assist" class="swb-btn swb-btn-link">支援升级</a>';
                        }
                        if(self.checkActionPerm('to_request_dispatch') && (row.state <= 3 || row.state == 7 || row.state == 15 || row.state == 16) && !row.invalid && row.state != self.supportedState && !row.grabFlag) {
                            domHtml = domHtml + '<a name="to_request_dispatch" class="swb-btn swb-btn-link">机构调度</a>';
                        }
                        if(self.checkActionPerm('relieve_serve_interrupt') && row.state == 7 && !row.invalid && row.state != self.supportedState) {
                            domHtml = domHtml + '<a name="relieve_serve_interrupt" class="swb-btn swb-btn-link">解除暂停</a>';
                        }
                        if(self.checkActionPerm('appoint_engineer') && row.engineerId == null && !row.invalid && row.servicerShopId != null && row.state != self.supportedState && !row.grabFlag) {
                            domHtml = domHtml + '<a name="appoint_engineer" class="swb-btn swb-btn-link">指派工程师</a>';
                        }
                        if(self.checkActionPerm('arrange_plan') && !row.invalid && row.state < 9) {
                            domHtml = domHtml + '<a name="arrange_plan" class="swb-btn swb-btn-link">安排计划</a>';
                        }
                        if(self.checkActionPerm('view_rec')) {
                            domHtml = domHtml + '<a name="view_rec" class="swb-btn swb-btn-link">查看操作记录</a>';
                        }
                        if(self.checkActionPerm('view_charge_item')) {
                            domHtml = domHtml + '<a name="view_charge_item" class="swb-btn swb-btn-link">查看收费项</a>';
                        }
                        if(self.showServcEval && row.evalFlag) {
                            domHtml = domHtml + '<a name="view-servc-eval" class="swb-btn swb-btn-link">查看评价</a>';
                        }
                        if(row.finished && (row.servcType == 0 || row.servcType == 1 || row.additionFlag)) {
                            domHtml = domHtml + '<a name="to-add-item-jsp" class="swb-btn swb-btn-link">查看补充项目</a>';
                        }
                        if(self.checkActionPerm('grab_set') && !row.invalid && !row.closed && !row.grabFlag && row.engineerId == null) {
                            domHtml = domHtml + '<a name="grab_set" class="swb-btn swb-btn-link">发起抢单</a>';
                        }
                        return domHtml;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'no': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'quali_claim') {
                            self.showQualiClaim(row.id);
                        }
                    },
                    'tradeNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.goToTradeVoucher(row.tradeNo, row.contractId);
                    },
                    'orderNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.toServcOrderInfo(row.orderId);
                    },
                    'staffQuali': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewStaffQuali(row);
                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'view_detail') { // 查看详情
                            self.toWorkVoucherDetail(row.id);
                        } else if(btnName == 'device-repair-rec') { // 维保记录
                            self.showDeviceRepairRec(row.tmpNo);
                        } else if(btnName == 'work_voucher_to_others') { // 转单
                            self.doToOthersOpt(row, row.ssuId);
                        } else if(btnName == 'invalidate') { // 作废
                            self.doInvalidate(row.id);
                        } else if(btnName == 'closed') { // 关闭
                            self.doClose(row.id);
                        } else if(btnName == 'to_request_assist') { // 支援升级
                            self.toRequestAssist(row.id, row.servicerComId1, row.servicerComLevel, row.svcDispLevel);
                        } else if(btnName == 'to_request_dispatch') { // 机构调度
                            self.toRequestDispatch(row.id, row.servicerComId);
                        } else if(btnName == 'relieve_serve_interrupt') { // 解除暂停
                            self.doRelieveServeInterrupt(row.id);
                        } else if(btnName == 'appoint_engineer') { // 指派工程师
                            self.doAppointEngineer(row, row.ssuId);
                        } else if(btnName == 'arrange_plan') { // 安排计划
                            self.doAppointEngineer(row, row.ssuId);
                        } else if(btnName == 'view_rec') { // 查看操作记录
                            self.toWorkVoucherRecs(row.id);
                        } else if(btnName == 'view_charge_item') { // 查看收费项
                            self.toChargeItems(row.id);
                        } else if(btnName == 'view-servc-eval') { // 查看评价
                            self.viewServcEval(row.id);
                        } else if(btnName == 'to-add-item-jsp') { // 查看补充项目
                            self.toAddItemJsp(row.id);
                        } else if(btnName == 'grab_set') { // 发起抢单
                            self.grabSet(row.id);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getMerchtFusedServcCat: function (callBack) {
                servcCategApi.getMerchtFusedServcCatListByMerchantId({}, function (result) {
                    if(result.type == "info") {
                        let rows = result.data;
                        let catList = [{
                            value: null,
                            label: '- 全部 -'
                        }];
                        if(rows != null && rows.length > 0) {
                            rows.forEach(function (item) {
                                let cat = {};
                                cat.value = item.catId;
                                cat.label = item.catName;
                                catList.push(cat);
                            });
                        }
                        callBack(catList);
                    }
                })
            },
            getServcWorkVoucherServicerTagList: function (callBack) {
                let postData = {};
                servcDelivApi.getServcWorkVoucherServicerTagList(postData, function (result) {
                    if(result.type === "info") {
                        let servicerTags = result.data;
                        let servicerTagList = [{
                            value: null,
                            label: '- 全部 -'
                        }];
                        if(servicerTags != null && servicerTags.length > 0) {
                            servicerTags.forEach(function (item) {
                                let queryItem = {};
                                queryItem.value = item;
                                queryItem.label = item;
                                servicerTagList.push(queryItem);
                            });
                        }
                        callBack(servicerTagList);
                    }
                })
            },
            getWorkServcType: function (callBack) {
                let workServcTypeList = [{
                    value: null,
                    label: '- 全部 -'
                }];
                let workServcTypes = getEnumList("workServcType");
                if(workServcTypes != null && workServcTypes.length > 0) {
                    workServcTypes.forEach(function (item) {
                        let queryItem = {};
                        queryItem.value = item.value;
                        queryItem.label = item.text;
                        workServcTypeList.push(queryItem);
                    });
                }
                callBack(workServcTypeList);
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getServcGroupNameByCatId(catId){
                return getServcGroupNameByCatId(catId);
            },
            goToTradeVoucher: function (tradeNo, contractId) {
                let tradeVoucherType = getEnumInfoWith('tradeVoucherType', 'name', 'GeneralVoucher').value;
                if(!Utils.isNoB(contractId)) {
                    tradeVoucherType = getEnumInfoWith('tradeVoucherType', 'name', 'ContractVoucher').value;
                }
                //
                this.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {no: tradeNo, tradeVoucherType: tradeVoucherType}
                });
            },
            showTreeCollapse: function (treeCollapse) {
//                console.log(treeCollapse);
                this.treeCollapse = treeCollapse;
            },
            checkComCatChange: function (eventData) {
                if(eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                    this.thisComLevel = eventData.level;
                    this.thisComId = eventData.id;
                    this.includeSubComs = eventData.includeSubComs;
                    this.getServcWorkVoucherList();
                }
            },
            // 当前用户信息
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext(null, function (result) {
                    if(result.type == 'info') {
                        let scopeEntity = result.data.scopeEntity;
                        self.merchantId = scopeEntity.id;
                        if(!Utils.isNoB(scopeEntity)) {
                            self.shopFlag = scopeEntity.shopFlag;
                            self.currentComId = scopeEntity.comId;
                            self.thisComLevel = scopeEntity.comLevel;
                            self.thisComId = scopeEntity.comId;
                            self.thisComName = scopeEntity.comName;
                        }
                    }
                });
            },
            //
            viewStaffQuali(servcWorkVoucher){
                let merchantType = 4;// 服务商
                let filter = {
                    merchantId: servcWorkVoucher.servicerId,
                    staffId: servcWorkVoucher.engineerId,
                    forEngineer: true,
                    checkFlag: 1 // 0:：未核对，1：核对有效，-1：核对无效
                };
                openStaffQualiForSelectDlg(merchantType, filter);
            },
            viewServcEval(workVoucherId){
                let pushDate = {};
                pushDate.path = SwbServcEvalList.path;
                if(workVoucherId != null) {
                    pushDate.query = {workVoucherId: workVoucherId};
                }
                this.$router.push(pushDate);
            },
            queryHandler: function (queryModel) {
                //
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getServcWorkVoucherList();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getServcWorkVoucherList();
            },
            getServcWorkVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                if(!Utils.isNoB(self.orderId)) {
                    filterItems.orderId = self.orderId;
                }
                if(!Utils.isNoB(self.reqVoucherId)) {
                    filterItems.reqVoucherId = self.reqVoucherId;
                }
                if(!Utils.isNoB(self.invalid)) {
                    filterItems.invalid = self.invalid;
                }
                if(!Utils.isNoB(filterItems.state)) {
                    let stateInfo = getEnumInfoWith('workAssignState', 'value', filterItems.state);
                    if(stateInfo != null) {
                        filterItems.invalid = false;
                        if(stateInfo.name == 'Invalid') {
                            filterItems.state = null;
                            filterItems.invalid = true;
                        }
                    }
                }
                if(filterItems.feeSource != null) {
                    if(filterItems.feeSource == "servcWorkVoucher") {
                        filterItems.maintFlag = false;
                        filterItems.comnRepairFlag = false;
                    } else if(filterItems.feeSource == "manualWorkVoucuher") {
                        filterItems.maintFlag = true;
                        filterItems.comnRepairFlag = false;
                    } else {
                        filterItems.maintFlag = false;
                        filterItems.comnRepairFlag = true;
                    }
                }
                //
                filterItems.servicerComId = this.thisComId;
                filterItems.comLevel = this.thisComLevel;
                filterItems.includeSubComs = this.includeSubComs;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                self.exportParams = filterItems;
                let loading = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherList(postData, function (result) {
                    if(result.type == "info") {
                        let servcWorkVoucherList = result.data.rows;
                        if(!Utils.isNoB(servcWorkVoucherList) && servcWorkVoucherList.length > 0) {
                            for(let i = 0; i < servcWorkVoucherList.length; i++) {
                                let servcWorkVoucher = servcWorkVoucherList[i];
                                let stateInfo = getEnumInfoWith('workAssignState', 'value', servcWorkVoucher.state);
                                servcWorkVoucher.stateText = stateInfo.text;
                                // 服务时长指标
                                let repaireTimeMi = servcWorkVoucher.repaireTimeMi == null ? 0 : servcWorkVoucher.repaireTimeMi;
                                let repaireTimeH = repaireTimeMi / 60;
                                repaireTimeH = repaireTimeH <= 8 ? repaireTimeH : (repaireTimeH > 8 && repaireTimeH <= 24 ? 8 : (8 * (repaireTimeH / 24)) + (repaireTimeH % 24));
                                servcWorkVoucher.repaireTimeH = repaireTimeH;
                                // 工单总用时指标
                                let arriveTimeMi = servcWorkVoucher.arriveTimeMi == null ? 0 : servcWorkVoucher.arriveTimeMi;
                                let repairedTimeMi = servcWorkVoucher.repairedTimeMi == null ? 0 : servcWorkVoucher.repairedTimeMi;
                                let servRepaireTimeMiH = ((arriveTimeMi + repairedTimeMi) / 60);
                                servRepaireTimeMiH = servRepaireTimeMiH <= 8 ? servRepaireTimeMiH : (servRepaireTimeMiH > 8 && servRepaireTimeMiH <= 24 ? 8 : (8 * (servRepaireTimeMiH / 24)) + (servRepaireTimeMiH % 24));
                                servcWorkVoucher.servRepaireTimeMiH = servRepaireTimeMiH;
                            }
                        }
                        //
                        let pagination = result.data.pagination;
                        self.renderTable(servcWorkVoucherList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                    loading.close();
                })
            },
            // 工单详情
            toWorkVoucherDetail: function (id) {
                openWorkVoucherDetailDlg(id);
            },
            // 查看操作记录
            toWorkVoucherRecs: function (id) {
                openWorkVoucherRecsDlg(id);
            },
            handleClick: function () {
                this.getServcWorkVoucherList();
            },
            // 转单
            doToOthersOpt: function (servcWorkVoucher, ssuId) {
                let self = this;
                self.$confirm('确定要进行转单操作吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    let title = '服务工单 - 转单';
                    let optFlag = 'change';
                    self.selectServcEngineers(servcWorkVoucher, ssuId, title, optFlag);
                }).catch(function () {
                });
            },
            // 指派工程师
            doAppointEngineer: function (servcWorkVoucher, ssuId) {
                let title = '服务工单 - 指派工程师';
                let optFlag = 'appoint';
                this.selectServcEngineers(servcWorkVoucher, ssuId, title, optFlag);
            },
            // 转单-选择服务工程师
            selectServcEngineers: function (servcWorkVoucher, ssuId, title, optFlag) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: title,
                    showCloseBtn: true,
                    width: 800,
                    height: 500,
                    template: '<div>' +
                    '<swb-to-change-engineer :optFlag="optFlag" :workVoucher="workVoucher" :ssuId="ssuId" :onlyShowAll="onlyShowAll" ref="swb_to_change_engineers"></swb-to-change-engineer>' +
                    '</div>',
                    data: {
                        optFlag: optFlag,
                        workVoucher: servcWorkVoucher,
                        ssuId: ssuId,
                        onlyShowAll: servcWorkVoucher.ids != null
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_to_change_engineers.getDlgResult() || {};
                        if(result != null && result.type === 'info') {
                            let servcWorkVoucherStaffList = result.data.servcWorkVoucherStaffList;
                            let chiefEngineerId = null;
                            servcWorkVoucherStaffList.forEach(function (engineer) {
                                if(engineer.chiefFlag) {
                                    chiefEngineerId = engineer.engineerId;
                                }
                            });
                            self.doServcWorkStaffQualiCheck({
                                voucherId: servcWorkVoucher.id,
                                voucherIds: servcWorkVoucher.ids,
                                engineerId: chiefEngineerId
                            }, function () {
                                let postData = {};
                                postData.id = servcWorkVoucher.id;
                                postData.servcWorkVoucherStaffList = servcWorkVoucherStaffList;
                                if(title.indexOf('指派') > -1) {
                                    postData.ids = servcWorkVoucher.ids;
                                    let theLoad = MsgBox.loading();
                                    servcDelivApi.appointServcWorkVoucherEngineer(postData, function (result) {
                                        theLoad.hide();
                                        if(result.type == "info") {
                                            theDlg.close();
                                            MsgBox.success("操作成功");
                                            self.getServcWorkVoucherList();
                                        } else {
                                            MsgBox.warning(result.message);
                                        }
                                    });
                                } else {
                                    //
                                    postData.transDesc = result.data.transDesc;
                                    //
                                    let theLoad = MsgBox.loading();
                                    servcDelivApi.changeServcWorkVoucher(postData, function (result) {
                                        theLoad.hide();
                                        if(result.type == "info") {
                                            theDlg.close();
                                            MsgBox.success("操作成功");
                                            self.getServcWorkVoucherList();
                                        } else {
                                            MsgBox.warning(result.message);
                                        }
                                    });
                                }
                            });
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    }
                });
            },
            doServcWorkStaffQualiCheck(postData, callback){
                let self = this;
                let msg = "工程师资质不满足,是否继续操作？";
                if(!Utils.isNoB(postData.voucherIds)) {
                    msg = "存在工程师资质不满足的工单,是否继续操作？";
                }
                let theLoad = MsgBox.loading();
                servcDelivApi.doServcWorkStaffQualiCheck(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        if(result.data) {
                            callback();
                        } else {
                            self.$confirm(msg, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                callback();
                            }).catch(function () {
                            });
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 作废操作
            doInvalidate: function (id) {
                let self = this;
                let dbGdInvalidCauseList = getEnumList("gdInvalidCause");
                let gdInvalidCauseList = [];
                for(let i = 0; i < dbGdInvalidCauseList.length; i++) {
                    let dbGdInvalidCause = dbGdInvalidCauseList[i];
                    if(dbGdInvalidCause.value <= 20 || dbGdInvalidCause.value == 28) {
                        gdInvalidCauseList.push(dbGdInvalidCause);
                    }
                }
                //
                Vue.$showDialog({
                    title: "工单作废",
                    showCloseBtn: true,
                    width: 500,
                    height: 240,
                    template: '<div>' +
                    '<div class="block-container">' +
                    '<div class="form-single">' +
                    '<div class="title required">作废原因</div>' +
                    '<div class="content" style="width: 350px">' +
                    '<el-select placeholder="请选择" class="fl" v-model="invalidCause" :clearable=true>' +
                    '<el-option v-for="gdInvalidCause in gdInvalidCauseList" :key="gdInvalidCause.value" :label="gdInvalidCause.text" :value="gdInvalidCause.value"></el-option>' +
                    '</el-select>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-single" v-if="invalidCause == othersVal">' +
                    '<div class="title required" style="width: 74px">作废说明</div>' +
                    '<div class="content" style="padding-left: 92px;width: auto;">' +
                    '<el-input type="textarea" v-model="causeDesc"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        gdInvalidCauseList: gdInvalidCauseList,
                        invalidCause: 1,
                        causeDesc: null,
                        othersVal: getEnumInfoWith('gdInvalidCause', 'name', 'Others').value
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        if(Utils.isNoB(selfDlg.invalidCause)) {
                            MsgBox.warning("请选择作废原因！");
                            return false;
                        }
                        if(selfDlg.invalidCause == selfDlg.othersVal) {
                            if(Utils.isNoB(selfDlg.causeDesc)) {
                                MsgBox.warning("请输入作废说明！");
                                return false;
                            }
                        }
                        let postData = {};
                        postData.id = id;
                        postData.invalidCause = selfDlg.invalidCause;
                        if(selfDlg.invalidCause == selfDlg.othersVal) {
                            postData.causeDesc = selfDlg.causeDesc;
                        }
                        let theLoad = MsgBox.loading();
                        servcDelivApi.invalidatedServcWorkVoucher(postData, function (result) {
                            theLoad.close();
                            if(result.type == "info") {
                                MsgBox.success("操作成功");
                                self.getServcWorkVoucherList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },
            // 关闭操作
            doClose: function (id) {
                let self = this;
                self.$confirm('确定要进行关闭操作吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    let theLoad = MsgBox.loading();
                    servcDelivApi.closeServcWorkVoucher(postData, function (result) {
                        theLoad.close();
                        if(result.type == "info") {
                            MsgBox.success("操作成功");
                            self.getServcWorkVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            doCloseForBatch: function () {  // 批量关闭
                let selectList = this.getTableSelection() || [];
                let workVoucherIds = selectList.pluck("id");
                if(Utils.isNoB(workVoucherIds) || workVoucherIds.length < 0) {
                    MsgBox.warning("请选择要关闭的工单！");
                    return false;
                }
                let self = this;
                self.$confirm('确定要执行批量关闭操作吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.ids = workVoucherIds;
                    let theLoad = MsgBox.loading();
                    servcDelivApi.closeServcWorkVoucherForBatch(postData, function (result) {
                        theLoad.close();
                        if(result.type == "info") {
                            MsgBox.success("操作成功");
                            setTimeout(function () {
                                self.getServcWorkVoucherList();
                            }, 1000);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 批量发起抢单
            doGrabSetBatch(){
                let selectList = this.getTableSelection() || [];
                let workVoucherIds = selectList.pluck("id");
                if(Utils.isNoB(workVoucherIds) || workVoucherIds.length < 0) {
                    MsgBox.warning("请选择要发起抢单的工单！");
                    return false;
                }
                let self = this;
                self.$confirm('确定要批量发起抢单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.ids = workVoucherIds;
                    let theLoad = MsgBox.loading();
                    servcDelivApi.updateGrabWorkBatch(postData, function (result) {
                        theLoad.close();
                        if(result.type == "info") {
                            MsgBox.success("操作成功");
                            setTimeout(function () {
                                self.getServcWorkVoucherList();
                            }, 1000);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 支援升级
            toRequestAssist: function (id, comId, currentLevel, svcDispLevel) {
                let self = this;
                self.$confirm('确定要进行该操作吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    self.doAssist(id, comId, currentLevel, svcDispLevel);
                }).catch(function () {
                });
            },
            // 支援公司窗口
            doAssist: function (id, comId, currentLevel, svcDispLevel) {
                let self = this;
                Vue.$showDialog({
                    title: '服务工单 - 支援升级',
                    showCloseBtn: true,
                    width: 1200,
                    height: 600,
                    template: '<div>' +
                    '<swb-servicer-com-for-select :checkBox=false :filter="filter" ref="swb_servicer_com_for_select"></swb-servicer-com-for-select>' +
                    '</div>',
                    data: {
                        filter: {
                            comId1: comId,
                            currentLevel: currentLevel,
                            dispLevel: svcDispLevel,
                            assistFlag: true // 是否为请求支援操作
                        }
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_servicer_com_for_select.getDlgResult() || {};
                        if(result != null && result.type === 'info') {
                            let checkedCom = result.data;
                            let postData = {};
                            postData.id = id;
                            postData.servicerShopId = checkedCom.id;
                            postData.servicerShopLevel = checkedCom.level;
                            postData.servicerShopName = checkedCom.name;
                            servcDelivApi.requestServcWorkVoucherAssist(postData, function (result) {
                                if(result.type == "info") {
                                    MsgBox.success("操作成功");
                                    self.getServcWorkVoucherList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                        }
                    }
                });
            },
            // 机构调度
            toRequestDispatch: function (id, comId) {
                let self = this;
                //
                let dlgConfig = {};
                dlgConfig.title = "服务工单 - 机构调度";
                dlgConfig.isRadio = true;
                dlgConfig.accordion = true;
                dlgConfig.isCom = true;
                dlgConfig.merchantId = self.merchantId;
                openServicerComTreeSelectDlg(dlgConfig, function (res) {
                    if(comId == res.id) {
                        MsgBox.warning("调度机构是本机构，不可重复调度！");
                        return;
                    }
                    let postData = {};
                    postData.id = id;
                    postData.servicerShopId = res.id;
                    postData.servicerShopLevel = res.level;
                    postData.servicerShopName = res.name;
                    let msgBox = MsgBox.loading();
                    servcDelivApi.requestServcWorkVoucherDispatch(postData, function (result) {
                        if(result.type == "info") {
                            msgBox.hide();
                            MsgBox.success("操作成功");
                            self.getServcWorkVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                });
            }
            ,
            // 解除暂停
            doRelieveServeInterrupt: function (id) {
                let self = this;
                self.$confirm('确定要执行该操作吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    let postData = {};
                    postData.id = id;
                    servcDelivApi.relieveServcWorkVoucherStateInterrupt(postData, function (result) {
                        if(result.type == "info") {
                            MsgBox.success("操作成功");
                            self.getServcWorkVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            }
            ,
            // 跳转到订单列表
            toServcOrderInfo: function (orderId) {
                this.$router.push({
                    path: SwbServcOrderOperate.path,
                    query: {
                        id: orderId
                    }
                });
            },
            // 查看收费项
            toChargeItems: function (workId) {
                Vue.$showDialog({
                    title: '工单 - 查看收费项',
                    showCloseBtn: true,
                    cancelText: '关闭',
                    okVisible: false,
                    width: 600,
                    height: 420,
                    template: '<div>' +
                    '<swb-servc-order-charge-item-list :workId="workId" ref="swb_servc_order_charge_item_list"></swb-servc-order-charge-item-list>' +
                    '</div>',
                    data: {
                        workId: workId,
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {
                        created: function () {
                        }
                    }
                });
            },
            showDeviceRepairRec: function (tmpNo) {      // 查看维保记录
                //
                openDeviceRepairRecDlg(tmpNo);
            },
            toArrangePlan(voucherId){
                let self = this;//
                Vue.$showDialog({
                    title: '服务工单 - 安排计划',
                    showCloseBtn: true,
                    width: 600,
                    height: 400,
                    template: '<div>' +
                    '<swb-servc-work-voucher-arrange-plan :voucherId="voucherId" ref="swb_servc_work_voucher_arrange_plan"></swb-servc-work-voucher-arrange-plan>' +
                    '</div>',
                    data: {
                        voucherId: voucherId
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_servc_work_voucher_arrange_plan.getDlgResult() || {};
                        if(result.type == 'info') {
                            let postData = result.data;
                            let msgBox = MsgBox.loading();
                            servcDelivApi.updateServcWorkVoucherPlanTime(postData, function (result) {
                                msgBox.hide();
                                if(result.type == "info") {
                                    MsgBox.success("操作成功");
                                    self.getServcWorkVoucherList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                            return true;
                        } else {
                            self.$message.warning(result.message);
                        }
                        return false;
                    }
                });
            },
            handleSelectionChange: function (selRows) {
                this.selectList = selRows;
            },
            toAddItemJsp(id){
                let url = __appBaseUrl + "/servc/work/add/item/jsp";
                let prevUrl = Utils.makeUrl(url, {voucherId: id});
                Utils.setPageUrl(prevUrl, '_blank');
            },
            exportExcel(){
                // 1.调用后台接口把查询参数放入redis
                let self = this;
                let theLoad = MsgBox.loading();
                let exportParams = this.exportParams;
                let selectList = this.getTableSelection() || [];
                exportParams.ids = selectList.pluck("id");
                //
                let totalCount = self.totalCount;
                if(selectList.length > 0) {
                    totalCount = selectList.length;
                }
                //
                let postData = {};
                let queryModel = this.queryModel;
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                postData.filterItems = exportParams;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                servcDelivApi.saveServcWorkVoucherForExport(postData, function (result) {
                    theLoad.hide();
                    if(!Utils.isNoB(result) && !Utils.isNoB(result.data)) {
                        let url = getAppUrl('/api/servcDeliv/servc/work/voucher/list/downLoad/do');
                        let pages = Math.ceil(totalCount / 1500);
                        let downloadUrls = [];
                        for(let i = 0; i < pages; i++) {
                            let params = {
                                url: url,
                                params: {
                                    uuid: result.data,
                                    pages: pages,
                                    pageNumber: i + 1,
                                    pageSize: 1500,
                                },
                                fileName: self.thisComName + "_服务工单_" + new Date().format("yyyy-MM-dd") + (pages == 1 ? '' : ("_" + (i + 1))),
                                seqNo: i + 1
                            };
                            downloadUrls.push(params);
                        }
                        showGrpDownloadDlg('服务工单 - 批量下载', downloadUrls);
                    } else {
                        MsgBox.warning("导出失败");
                    }
                });
            },
            doUpdatePerformFlagBatch(){
                let selectList = this.getTableSelection() || [];
                if(Utils.isNoB(selectList) || selectList.length <= 0) {
                    MsgBox.warning("请选择要设置的工单！");
                    return false;
                }
                let workVoucherIds = selectList.pluck("id");
                this.updatePerformFlagBatchDlg(workVoucherIds);
            },
            updatePerformFlagBatchDlg(workVoucherIds) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '绩效标记 - 设置',
                    showCloseBtn: true,
                    width: 500,
                    height: 300,
                    template: '<div class="form-info">' +
                    '   <div class="form-row">' +
                    '        <div class="form-label">' +
                    '            <label>绩效标记</label>' +
                    '        </div>' +
                    '        <div class="form-value">' +
                    '            <el-select v-model="performFlag">' +
                    '                <el-option v-for="item in performFlagEnumList" :label="item.text" :value="item.value"></el-option>' +
                    '            </el-select>' +
                    '        </div>' +
                    '    </div>' +
                    '   <div class="form-row" v-if="performFlag == 2">' +
                    '        <div class="form-label">' +
                    '            <label >计件比率(%)</label>' +
                    '        </div>' +
                    '        <div class="form-value">' +
                    '            <el-input class="align-right" type="number" :max="100" :min="0" step="1" v-model="jbRatio"></el-input>' +
                    '            <div class="input-tip error">0% ~ 100%</div>' +
                    '        </div>' +
                    '    </div>' +
                    '</div>',
                    data: {
                        performFlag: 0,
                        jbRatio: 0,
                        performFlagEnumList: getEnumList("performFlag")
                    },
                    methods: {},
                    okClicked: function () {
                        let performFlag = this.performFlag;
                        let jbRatio = this.jbRatio;
                        if(!Utils.isNaturalStr(jbRatio) || jbRatio < 0 || jbRatio > 100) {
                            self.$message.warning("计件比率必须是整数且在 0% ~ 100% 之间");
                            return false;
                        }
                        if(jbRatio != 0) {
                            jbRatio = jbRatio / 100;
                        }
                        let postData = {};
                        postData.idList = workVoucherIds;
                        postData.performFlag = performFlag;
                        postData.jbRatio = jbRatio;
                        // 设置绩效标记
                        let theLoad = MsgBox.loading();
                        servcDelivApi.updateServcWorkVoucherPerformFlagBatch(postData, function (result) {
                            theLoad.hide();
                            if(result.type == 'info') {
                                MsgBox.success("设置成功！");
                                self.getServcWorkVoucherList();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                        return true;
                    }
                });
            },
            getServicerTagList: function () {
                let self = this;
                let retaTagList = [];
                let servicerTags = null;
                let postData = {};
                servcDelivApi.getServcWorkVoucherServicerTagList(postData, function (result) {
                    if(result.type === "info") {
                        servicerTags = result.data;
                        if(servicerTags != null && servicerTags.length > 0) {
                            servicerTags.forEach(function (item) {
                                let queryItem = {};
                                queryItem.value = item;
                                queryItem.label = item;
                                retaTagList.push(queryItem);
                            });
                        }
                        let servicerTagLists = self.servicerTagList;
                        if(null == retaTagList || null == servicerTagLists || retaTagList.length != servicerTagLists.length) {
                            self.refreshFlag = new Date().getTime();
                        } else {
                            for(let i = 0; i < retaTagList.length; i++) {
                                let value = retaTagList[i].value;
                                for(let j = servicerTagLists.length - 1; j >= 0; j--) {
                                    let value2 = servicerTagLists[j].value;
                                    if(value == value2) {
                                        servicerTagLists.splice(j, 1);
                                    }
                                }
                            }
                            if(servicerTagLists.length > 0) {
                                self.refreshFlag = new Date().getTime();
                            }
                        }
                        self.servicerTagList = retaTagList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            toServicerTag: function () {
                let self = this;
                let selectList = this.getTableSelection() || [];
                if(Utils.isNoB(selectList) || selectList.length <= 0) {
                    MsgBox.warning("请选择要设置的工单！");
                    return false;
                }
                let servicerTag = selectList[0].servicerTag;
                for(let i = 0; i < selectList.length; i++) {
                    let item = selectList[i];
                    if(item.servicerTag != servicerTag) {
                        servicerTag = null;
                    }
                }
                self.showServicerTagDialog(servicerTag);
//                if(promptMsgList.length > 0) {
//                    let tag = promptMsgList.join(" ; ");
//                    let prompt = '提示-是否设置或修改';
//                    this.$confirm(tag, prompt, {
//                        confirmButtonText: '确定',
//                        cancelButtonText: '取消',
//                        type: 'warning'
//                    }).then(function () {
//                        self.showServicerTagDialog();
//                    }).catch(function () {
//                    });
//                }else {
//                    self.showServicerTagDialog();
//                }
            },
            showServicerTagDialog: function (sTag) {
                let self = this;
                let servicerTagList = this.servicerTagList;
                let servicerTag = sTag;
                let selectList = this.getTableSelection() || [];
                let idList = selectList.pluck("id");
                let title = "业务标签 - 设置";
                let theDlg = Vue.$showDialog({
                    title: title,
                    width: 540,
                    height: 300,
                    showCloseBtn: true,
                    template: '<div class="form-info">' +
                    '<div class="form-row">' +
                    '<div class="form-label">' +
                    '<label class="required">业务标签:</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    ' <el-autocomplete class="inline-input" type="text"  style="width:240px;" v-model="servicerTag" :fetch-suggestions="querySearch" placeholder="请填写业务标签" ></el-autocomplete>' +
                    '</el-select>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        servicerTag: servicerTag,
                        servicerTagList: servicerTagList
                    },
                    okClicked: function () {
                        if(!Utils.isNoB(this.servicerTag)) {
                            if(this.servicerTag.length > 30) {
                                MsgBox.warning("标签不能大于30个字");
                                return false;
                            }
                            let tag = this.servicerTag;
                            this.$confirm('确定要设置或修改业务标签吗?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                let postData = {};
                                postData.idList = idList;
                                postData.servicerTag = tag;
                                let theLoad = MsgBox.loading();
                                servcDelivApi.doBatchServicerTag(postData, function (result) {
                                    theLoad.hide();
                                    if(result.type === "info") {
                                        //
                                        theDlg.close();
                                        MsgBox.success("设置成功！");
                                        self.getServcWorkVoucherList();
                                        self.getServicerTagList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            }).catch(function () {
                            });
                        } else {
                            MsgBox.warning("标签不能为空");
                        }
                        return false;
                    },
                    methods: {
                        querySearch(queryString, cb) {
                            var servicerTagList = this.servicerTagList;
                            var results = queryString ? servicerTagList.filter(this.createFilter(queryString)) : servicerTagList;
                            // 调用 callback 返回建议列表的数据
                            cb(results);
                        },
                        createFilter(queryString) {
                            return (restaurant) => {
                                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                            };
                        },
                    }
                });
            },
            grabSet(id){
                let self = this;
                self.$confirm('确定要发起抢单吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    servcDelivApi.updateGrabWork(id, function (result) {
                        if(result.type == "info") {
                            MsgBox.success("操作成功");
                            self.getServcWorkVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            showQualiClaim(voucherId){
                openServcWorkStaffQualiDlg(voucherId);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherList.vue